function Tool(_) {
  return null;
}
export {
  Tool
};
//# sourceMappingURL=Tool.js.map
